export type AccessLevelOption = {
  label: string;
  value: string;
};

export const DEFAULT_ACCESS_LEVEL_OPTIONS: ReadonlyArray<AccessLevelOption> = [
  {
    label: 'Update',
    value: 'Update'
  },
  {
    label: 'Inquiry',
    value: 'Inquiry'
  },
  {
    label: 'None',
    value: 'None'
  }
];

export function filterAccessOptions(options: ReadonlyArray<AccessLevelOption>, accessLevel?: string): AccessLevelOption[] {
  if (accessLevel === 'Inquiry') {
    return options.filter(option => option.value !== 'Update');
  }

  if (accessLevel === 'None') {
    return options.filter(option => option.value === 'None');
  }

  return [...options];
}
